
export function headerBtn() {
	const btn = document.querySelector('.gnav__btn');
	var menu_target = document.querySelector('.gnav');




	let state = false;

	btn.addEventListener("click", function () {
		let scrollbarWidth = window.innerWidth - document.body.clientWidth;
		const vh = window.innerHeight;
		const windowHeight = document.documentElement.clientHeight;
		const header = document.querySelector('.header');
		const headerHeight = header.offsetHeight;

		if (state == false) {
			this.classList.add('active');
			//html.classList.add('fixed');
			menu_target.classList.add('active');
			document.querySelector('body').classList.add('fixed');
			btn.style.marginRight = scrollbarWidth + 'px';
			document.querySelector('body').style.marginRight = scrollbarWidth + 'px';
			header.style.paddingRight = scrollbarWidth + 'px';
			state = true;
		} else {
			this.classList.remove('active');
			//html.classList.remove('fixed');
			menu_target.classList.remove('active');
			document.querySelector('body').classList.remove('fixed');
			btn.style.marginRight = '0px';
			document.querySelector('body').style.marginRight = '0px';
			header.style.paddingRight = '0px';
			state = false;
		}
	});

	//アンカーリンク
	const anchorLinks = document.querySelectorAll('a[href^="#"]');
	const anchorLinksArr = Array.prototype.slice.call(anchorLinks);
	const header = document.querySelector('.header');
	const anchorHash = location.hash;

	//ハッシュ値でのアンカーリンク
	anchorLinksArr.forEach(link => {
		link.addEventListener('click', e => {
			e.preventDefault();
			const targetId = link.hash;
			const targetElement = document.querySelector(targetId);
			const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
			const headerHeight = 0;
			//const totalScrollAmount = targetOffsetTop - headerHeight;
			const totalScrollAmount = targetOffsetTop - headerHeight;
			window.scrollTo({
				top: totalScrollAmount,
				behavior: "smooth"
			});

			btn.classList.remove('active');
			//html.classList.remove('fixed');
			menu_target.classList.remove('active');
			document.querySelector('body').classList.remove('fixed');
			btn.style.marginRight = '0px';
			document.querySelector('body').style.marginRight = '0px';
			state = false;
		});
	});

	if (anchorHash) {
		window.scrollTo({
			top: 0,
			behavior: "instant"
		});
		const targetElement = document.querySelector(anchorHash);
		const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
		const headerHeight = 0;
		const totalScrollAmount = targetOffsetTop - headerHeight;
		//const totalScrollAmount = targetOffsetTop - 40;

		var fn = function () {
			window.scrollTo({
				top: totalScrollAmount,
				behavior: "smooth"
			});
		};
		var tm = 500;
		setTimeout(fn, tm);
	}

}
